import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import PublicOnlyRoute from "./PublicOnlyRoute";
import ProtectedRoute from "./ProtectedRoute";
import AdminOnlyRoute from "./AdminOnlyRoute";
import LoginPage from "../pages/LoginPage";
import HistoryPage from "../pages/HistoryPage";
import UploadPage from "../pages/UploadPage";

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicOnlyRoute>
              <LoginPage />
            </PublicOnlyRoute>
          }
        />

        <Route
          path="/history"
          element={
            <ProtectedRoute>
              <HistoryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/upload"
          element={
            <AdminOnlyRoute>
              <UploadPage />
            </AdminOnlyRoute>
          }
        />

        {/* Legacy /dashboard route preserved for backward-compatibility */}
        <Route path="/dashboard" element={<Navigate to="/history" replace />} />

        <Route path="/" element={<Navigate to="/history" replace />} />
        <Route path="*" element={<Navigate to="/history" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
